import React from "react"
import { getSrc } from "gatsby-plugin-image"
import GGFXTransform from "../components/common/stb-jamstack-ggfxclient/module/components/ggfx-transform";
import NoImage from "../images/no-image.png"

export const ImageModule = (props) => {
        if(props.ImageSrc && props.ImageSrc.url){

        var image_url = props.ImageSrc.url;
        if(props.ImageSrc.url_sharp){
            image_url = getSrc(props.ImageSrc.url_sharp)
        }

        let alt_text = props.altText ? props.altText : props.ImageSrc.alternativeText;
        let renderer = props.renderer ? props.renderer :"srcSet";
        return(
            <>
                {
                    props.imagename ? (<>
                      <GGFXTransform mediaUrl={decodeURIComponent(props.ImageSrc.url)} altText={alt_text} renderer={renderer} 
                    transformConfigName={props.imagename} 
                    preResult={props?.ggfx_results} id={props.strapi_id} /> </>
                    ) : (
                        <img className={props.classNames} src={image_url} alt={alt_text} title={props.title} loading="lazy" />
                    )
                }
                
            </>
        )
    } else{
        return <img src={NoImage} alt={props.altText || "img"} />;
    }
}
